import React, { useState, useEffect } from "react";
import * as infrastructureService from "@/shared/api/services/infrastructure";
import ServerLogsDialog from "./ServerLogsDialog";

/**
 * A wrapper component for ServerLogsDialog that handles data fetching
 * when a server is selected for viewing logs.
 */
export default function LogsModalWithData({
  selectedServer,
  onClose,
  translateLogStatus,
}) {
  const [logStatusFilter, setLogStatusFilter] = useState("ALL");
  const [logStartDate, setLogStartDate] = useState("");
  const [logEndDate, setLogEndDate] = useState("");
  const [serverLogs, setServerLogs] = useState(null);
  const [loadingLogs, setLoadingLogs] = useState(false);

  const fetchLogs = async () => {
    if (!selectedServer) return;
    setLoadingLogs(true);
    try {
      const data = await infrastructureService.getLogs(
        selectedServer,
        logStartDate || null,
        logEndDate || null
      );
      setServerLogs(data);
    } catch (err) {
      console.error("Failed to fetch logs:", err);
      setServerLogs({ error: err.message || "Failed to load logs", logs: [] });
    } finally {
      setLoadingLogs(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [selectedServer, logStartDate, logEndDate]);

  return (
    <ServerLogsDialog
      open={!!selectedServer}
      onOpenChange={(open) => !open && onClose()}
      selectedServerForLogs={selectedServer}
      serverLogs={serverLogs}
      loadingLogs={loadingLogs}
      logStatusFilter={logStatusFilter}
      setLogStatusFilter={setLogStatusFilter}
      logStartDate={logStartDate}
      setLogStartDate={setLogStartDate}
      logEndDate={logEndDate}
      setLogEndDate={setLogEndDate}
      onFetchLogs={fetchLogs}
      translateLogStatus={translateLogStatus}
    />
  );
}
